import React from 'react'

import { LessonFaqs } from '../../utilities/constants'
import LessonFaqAccordion from './LessonFaqAccordion'


const LessonFaq = () => {
    

   return (
        <div className='flex flex-col w-full'>
            {LessonFaqs?.map(({ question, answer }, index) => (
                <LessonFaqAccordion title={question} key={index} index={index} length={LessonFaqs?.length} content={answer}/>
            ))}
        </div>
    )
}

export default LessonFaq
